import React from 'react'
import { Card } from 'react-bootstrap'
import classNames from 'classnames'
import '../Card/CommonCard.scss'
import styles from './AddAppCard.module.scss'

interface AddAppCardProps {
  label: string
  onClick: () => void
}

export const AddAppCard: React.FC<AddAppCardProps> = ({ label, onClick }) => {
  return (
    <Card role='button' className={classNames('common-card rounded-3 d-flex align-items-center justify-content-center', styles.addCard)} onClick={onClick}>
      <div className={classNames('d-flex flex-column align-items-center zocks-gap-1.25 zocks-text-primary text-center', styles.content)}>
        <i className={classNames('bi bi-plus-circle', styles.icon)} />
        <span className='heading-small'>{label}</span>
      </div>
    </Card>
  )
}
